<template>
  <v-card>
    <v-row justify="center">
      <v-col cols="12">
        <v-form ref="formDocuments">
          <p class="text-h5">{{ languageData.labels.documents }}</p>

          <div class="box" @dragenter.prevent @dragover.prevent @drop.prevent="dropDocuments" @click="$refs.fileInput.click()" style="cursor: pointer">
            <i style="font-size: 64px" class="material-icons mt-0">cloud_upload</i>
            <input accept=".pdf, .doc, .docx, .jpg, .jpeg, .gif, .png, .xls, .xlsx, .txt" type="file" @change="setDocuments" class="d-none" ref="fileInput" multiple>
            <label><span style="line-height: 18px">{{ languageData.dragAndDrop }}</span><span style="display: block; margin-top: 15px; line-height: 18px"> {{ languageData.maxFileSize }}</span></label>
            <div class="mt-4" v-if ="documentableType === 'project' && projectDiskCapacityInMb">
              <p class="mb-1">{{ languageData.diskUsage }}</p>
              <v-progress-linear
                v-model="projectDiskUsageInPercents"
                color="primary"
                rounded
                height="35"
              >
                <strong>{{ projectDiskUsageInPercents + '% ' + `(${projectDiskUsageInMb.toFixed(2)}MB/${projectDiskCapacityInMb.toFixed(2)}MB)` }}</strong>
              </v-progress-linear>
            </div>
            <div class="mt-4" v-else-if ="documentableType === 'client' && clientDiskCapacityInMb">
              <p class="mb-1">{{ languageData.diskUsage }}</p>
              <v-progress-linear
                v-model="clientDiskUsageInPercents"
                color="primary"
                rounded
                height="35"
              >
                <strong>{{ clientDiskUsageInPercents + '% ' + `(${clientDiskUsageInMb.toFixed(2)}MB/${clientDiskCapacityInMb.toFixed(2)}MB)` }}</strong>
              </v-progress-linear>
            </div>
          </div>
        </v-form>

        <div class="mt-5" :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
          <v-select
              :label="languageData.labels.document_type"
              :items="documentTypes[documentableType]"
              @change="filterDocuments"
              v-model="filterDocument"
              outlined
              item-value="value"
              item-text="name">
            <template slot='selection' slot-scope='{ item }'>
              {{ documentableType === 'project' ? languageData.documentProjectTypes[item.value] : languageData.documentClientTypes[item.value] }}
            </template>
            <template slot='item' slot-scope='{ item }'>
              {{ documentableType === 'project' ? languageData.documentProjectTypes[item.value] : languageData.documentClientTypes[item.value] }}
            </template>
          </v-select>
        </div>

        <DocumentsTable :projectClients="projectClients" :documentableType="documentableType"></DocumentsTable>

      </v-col>
    </v-row>
  </v-card>
</template>

<script type="text/javascript">
  import DocumentsTable from "../DocumentsTable/DocumentsTable";
  import { mapActions, mapState } from "vuex";
  import eventBus from "../../../../event-bus/eventBus";
  import { documentTypes } from "../../enums/documentTypes";

  export default {
    name: "Documents",
    props: {
      documentableType: String,
      projectClients: Array,
      diskUsage: Object,
    },
    components: {
      DocumentsTable
    },
    data() {
      return {
        documentTypes: documentTypes,
        filterDocument: 0
      }
    },
    computed: {
      ...mapState("getProjectDiskUsage", {
        projectDiskCapacityInMb: state => state.projectDiskCapacityInMb,
        projectDiskUsageInMb: state => state.projectDiskUsageInMb,
        projectDiskUsageInPercents: state => state.projectDiskUsageInPercents
      }),
       ...mapState("getClientDiskUsage", {
        clientDiskCapacityInMb: state => state.clientDiskCapacityInMb,
        clientDiskUsageInMb: state => state.clientDiskUsageInMb,
        clientDiskUsageInPercents: state => state.clientDiskUsageInPercents
      }),
    },
    methods: {
      ...mapActions("getHeadersDocuments", ["getHeadersDocuments"]),
      ...mapActions("getDocuments", ["getDocuments"]),
      ...mapActions("getProjectDiskUsage", ["getProjectDiskUsageRequest"]),
      ...mapActions("getClientDiskUsage", ["getClientDiskUsageRequest"]),

      dropDocuments: function(e) {
        this.saveDocuments(e.dataTransfer.files);
      },
      saveDocuments: function(files) {
        ([...files]).forEach(file => {
          const reader = new FileReader();
          reader.onloadend = async () => {
            let item = {
              "base64": reader.result,
              "date": "0",
              "type": "",
              "loadingVisible": true,
              "title": "",
              "file": file,
              "fileName": file["name"],
              "fileSize": file["size"],
              "id": null,
              "documentableType": this.documentableType,
              "canOpenFile": ["pdf", "png", "jpg", "jpeg", "gif"].includes(file["name"].replace(/^.*\./, ''))
            }
            eventBus.$emit("pushDocument", item);
          }
          reader.readAsDataURL(file)
        });
      },
      setDocuments: function(e) {
        this.saveDocuments(e.target.files);
      },
      filterDocuments: function() {
        let type = this.filterDocument;
        let documentableType = this.documentableType;
        this.getDocuments({ creds: { type, documentableType } });
      },
    },
    mounted() {
      this.filterDocuments();
      eventBus.$on("filterDocuments", () => {
        this.filterDocuments();
      });
      if (this.$route.name === 'ProjectsEdit') {
        this.getProjectDiskUsageRequest();
      } else if (this.$route.name === 'ClientsEdit') {
        this.getClientDiskUsageRequest();
      }
      eventBus.$on(["saveInvoiceSuccess", "storeAndSendInvoiceSuccess"], () => {
        if (this.$route.name === 'ProjectsEdit') {
          this.getProjectDiskUsageRequest();
        }  
      });
      eventBus.$on("sendTimeReportSuccess", () => {
        if (this.$route.name === 'ProjectsEdit') {
          this.filterDocuments();
        }
      });
      eventBus.$on("saveTimeReportPDFSuccess", () => {
        if (this.$route.name === 'ProjectsEdit') {
          this.getProjectDiskUsageRequest();
          this.filterDocuments();
        } else if (this.$route.name === 'ClientsEdit') {
          this.getClientDiskUsageRequest();
        }    
      });
      eventBus.$on("successDeleteMeasurement", () => {
        this.filterDocuments();
      })
    },
    beforeDestroy() {
      eventBus.$off("filterDocuments")
    }
  }
</script>
